export const ManageAnnouncementsMachine = {
    initial: 'View',
    states: {
        View: {
            on: {
                RETURN: 'stop',
            }
        },
        stop: {

        }
    }
}